// extracted by mini-css-extract-plugin
export default {"problem":"Problem_problem__mSO6G","problemBox":"Problem_problemBox__coMgT"};